module.exports = __webpack_public_path__ + "static/b_ru-0374d914d085e655d85310b41e01f584.jpeg";